export default {
    home: {
      webPage: '网页',
      picture: '图片',
      noPage: '暂时没有页面',
      close:'关闭',
      reback:'返回',
      subMit:'提交',
      informationFeedback:'信息反馈',
      about:'关于我们',
      homePage:'首页',
      userName:'姓名',
      address:'地址',
      telephone:'手机',
      cellphone:'电话',
      mailbox:'邮箱',
      content:'内容',
      firstCatelog:'一级分类',
      secondCatelog:'二级分类',
      contactUs:'联系我们',
      title:'菲律宾优信人力资源',
      partner:'合作伙伴',
      more:'查看更多',
    }
}



// WEBPACK FOOTER //
// ./src/i18n/zh/index.js